var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTravel(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.31 19.4C14.35 20.4 13.25 21.43 12 22.5C6.67 17.95 4 14.02 4 10.7C4 5.72 7.8 2.5 12 2.5C16 2.5 19.64 5.42 19.97 10H23.5L19 14.5L14.5 10H17.97C17.65 6.74 15.13 4.5 12 4.5C8.65 4.5 6 7.07 6 10.7C6 13.04 7.95 16.14 12 19.84C12.64 19.25 13.23 18.68 13.77 18.13C13.594 17.7828 13.5016 17.3993 13.5 17.01C13.5 16.347 13.7634 15.7111 14.2322 15.2422C14.7011 14.7734 15.337 14.51 16 14.51C16.663 14.51 17.2989 14.7734 17.7678 15.2422C18.2366 15.7111 18.5 16.347 18.5 17.01C18.4997 17.3967 18.4093 17.778 18.2361 18.1238C18.0629 18.4695 17.8117 18.7702 17.5022 19.0021C17.1927 19.234 16.8335 19.3906 16.453 19.4597C16.0726 19.5287 15.6812 19.5083 15.31 19.4V19.4Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTravel);
export default __webpack_public_path__ + "static/media/icon-travel.ed3b152f.svg";
export { ForwardRef as ReactComponent };